(function () {
var $197cd56b15c33885$exports = {};
// @ts-nocheck
/* eslint-disable no-undef */ /* eslint-disable no-unused-vars */ "use strict";
var $197cd56b15c33885$var$swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    // centeredSlides: true,
    spaceBetween: 20,
    slidesPerView: "auto",
    effect: "slide",
    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});
/* #region hide menu icon on click */ var $197cd56b15c33885$var$menuIcon = document.querySelector(".page__menu-icon-img");
var $197cd56b15c33885$var$closeIcon = document.querySelector(".menu__close-link");
var $197cd56b15c33885$var$menuLinks = document.querySelectorAll(".menu__nav-list .menu__nav-list-item");
$197cd56b15c33885$var$menuIcon === null || $197cd56b15c33885$var$menuIcon === void 0 ? void 0 : $197cd56b15c33885$var$menuIcon.addEventListener("click", function() {
    $197cd56b15c33885$var$menuIcon.classList.toggle("page__menu-icon-img--hide-show");
});
$197cd56b15c33885$var$closeIcon === null || $197cd56b15c33885$var$closeIcon === void 0 ? void 0 : $197cd56b15c33885$var$closeIcon.addEventListener("click", function() {
    $197cd56b15c33885$var$menuIcon.classList.toggle("page__menu-icon-img--hide-show");
});
$197cd56b15c33885$var$menuLinks === null || $197cd56b15c33885$var$menuLinks === void 0 ? void 0 : $197cd56b15c33885$var$menuLinks.forEach(function(node) {
    node === null || node === void 0 ? void 0 : node.addEventListener("click", function() {
        $197cd56b15c33885$var$menuIcon.classList.toggle("page__menu-icon-img--hide-show");
    });
}); /* #end hide menu icon on click */ 

})();
//# sourceMappingURL=index.11a4a50d.js.map
